import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import BookingModal from "./components/BookingModal";
import ScrollToTop from "./components/ScrollToTop";
import RotatingContactButton from "./components/RotatingContactButton";

import Home from "./pages/Home";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import About from "./pages/About";
import Gallery from "./pages/Gallery";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Careers from "./pages/Careers";
import JobDetail from "./pages/JobDetail";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import Approvals from "./pages/Approvals";

import AdminLayout from "./admin/AdminLayout";
import AdminDashboard from "./admin/AdminDashboard";
import ProjectsAdmin from "./admin/ProjectsAdmin";
import GalleryAdmin from "./admin/GalleryAdmin";
import ContactSettings from "./admin/ContactSettings";
import JobsAdmin from "./admin/JobsAdmin";
import ApplicantsAdmin from "./admin/ApplicantsAdmin";
import AdminLogin from "./admin/AdminLogin";
import AdminProfile from "./admin/AdminProfile";

import { ProjectsProvider } from "./admin/ProjectsContext";
import { JobsProvider } from "./admin/JobsContext";

import ProtectedRoute from "./admin/ProtectedRoute";
import AdminBlog from "./admin/AdminBlog";

function App() {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin-dashboard");

  const handleBookingClick = (projectName = null) => {
    setSelectedProject(projectName);
    setIsBookingModalOpen(true);
  };

  return (
    <ProjectsProvider>
      <JobsProvider>
        <div className="App">
          <ScrollToTop />
          {!isAdminRoute && <Header onBookingClick={handleBookingClick} />}

          <Routes>
            {/* PUBLIC ROUTES */}
            <Route
              path="/"
              element={<Home onBookingClick={handleBookingClick} />}
            />
            <Route path="/projects" element={<Projects />} />
            <Route
              path="/projects/:id"
              element={<ProjectDetail onBookingClick={handleBookingClick} />}
            />
            <Route path="/about" element={<About />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/careers/:slug" element={<JobDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
            <Route path="/approvals" element={<Approvals />} />

            {/* ADMIN LOGIN */}
            <Route path="/login" element={<AdminLogin />} />

            {/* ADMIN DASHBOARD PROTECTED */}
            {/* ADMIN DASHBOARD PROTECTED */}
            <Route
              path="/admin-dashboard/*"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminDashboard />} />
              <Route path="projects" element={<ProjectsAdmin />} />
              <Route path="gallery" element={<GalleryAdmin />} />
              <Route path="careers" element={<JobsAdmin />} />
              <Route path="applicants" element={<ApplicantsAdmin />} />
              <Route path="contact-settings" element={<ContactSettings />} />
              <Route path="blog" element={<AdminBlog />} />
              <Route path="profile" element={<AdminProfile />} />
            </Route>
          </Routes>

          {!isAdminRoute && <RotatingContactButton />}
          {!isAdminRoute && <Footer />}

          <BookingModal
            isOpen={isBookingModalOpen}
            onClose={() => setIsBookingModalOpen(false)}
            selectedProject={selectedProject}
          />
        </div>
      </JobsProvider>
    </ProjectsProvider>
  );
}

export default App;
